class UnresponsivePatientsComponent {
  constructor($state) {
    Object.assign(this, {
      searchTerm: $state.params.search,
      page: {
        limit: parseInt($state.params.limit),
        offset: (parseInt($state.params.number) - 1) * parseInt($state.params.limit),
      },
    });
  }
}

UnresponsivePatientsComponent.$inject = ['$state'];
angular.module('pims').controller('UnresponsivePatients', UnresponsivePatientsComponent);
